export default "__VITE_ASSET__DpZ_GSXm__"